import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useEffect, useState } from "react";
import { List, Span } from "@catchoftheday/cg-components";
import { SEARCH_FACET_FILTERED_DISPLAY_AMOUNT, SEARCH_FACET_NESTED_DISPLAY_AMOUNT, SEARCH_FACET_TYPE_NESTED_SINGLE } from "@search-app/helpers/search/search.helpers.facets";
import { SEARCH_URL_PARAM_FACET } from "@search-app/helpers/search/search.helpers.params";
import { facetAppliedCount } from "@search-app/utilities/facets/applied";
import getSelectedNames from "@search-app/utilities/search/search.utilities.getSelectedNames";
import { FacetCount, FacetSubList, FacetSubListItem } from "../../SearchFacets.styles";
import { SearchFacetsBody } from "../SearchFacetsBody";
import { SearchFacetsContainer } from "../SearchFacetsContainer";
import { SearchFacetsHeader } from "../SearchFacetsHeader";
import { SearchFacetsListItem } from "../SearchFacetsListItem";
import { ShowMore } from "../SearchFacetsShowMore/SearchFacetsShowMore";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var SearchFacetsNestedSingle = function SearchFacetsNestedSingle(_ref) {
  var facet = _ref.facet,
      isClearAll = _ref.isClearAll,
      isExpanded = _ref.isExpanded,
      searchTimeout = _ref.searchTimeout,
      onClear = _ref.onClear,
      onChange = _ref.onChange,
      onExpandChange = _ref.onExpandChange;
  var id = facet.id,
      name = facet.name,
      values = facet.values;
  var facetId = "".concat(SEARCH_URL_PARAM_FACET, "[").concat(id, "]");
  var inputRef = /*#__PURE__*/React.createRef();
  var totalSelected = facetAppliedCount(facet);

  var _useState = useState(-1),
      filteredListFocusIndex = _useState[0],
      setFilteredListFocusIndex = _useState[1];

  var _useState2 = useState([]),
      expandedCategories = _useState2[0],
      setExpandedCategories = _useState2[1];

  var _useState3 = useState(values.filter(function (value) {
    return value.selected;
  }).map(function (value) {
    return _objectSpread({}, value);
  })),
      selectedValues = _useState3[0],
      setSelectedValues = _useState3[1];

  useEffect(function () {
    var updatedSelectedValues;

    if (isClearAll) {
      updatedSelectedValues = [];
      setFilteredListFocusIndex(-1);
    } else {
      updatedSelectedValues = _toConsumableArray(selectedValues);

      var _loop = function _loop(i) {
        var index = values.findIndex(function (value) {
          return value.name === updatedSelectedValues[i].name;
        });

        if (index === -1) {
          updatedSelectedValues[i].count = 0;
        } else {
          updatedSelectedValues[i].count = values[index].count;
        }
      };

      for (var i = 0; i < updatedSelectedValues.length; i++) {
        _loop(i);
      }
    }

    setSelectedValues(updatedSelectedValues); // FIXME: Adding selectedValues as a dependency causes an infinite loop.
    // Find a way to resolve this lint issue, or disable it.
  }, [values, isClearAll]);
  var selectedNames = getSelectedNames(selectedValues);
  var onClearHandler = useCallback(function () {
    setSelectedValues([]);
    setExpandedCategories([]);

    if (onClear) {
      onClear({
        facet: id
      });
    }
  }, [onClear, id]);
  var toggleValues = useCallback(function (tag, select) {
    onChange({
      facet: id,
      value: tag.id,
      type: SEARCH_FACET_TYPE_NESTED_SINGLE
    });

    if (select) {
      setFilteredListFocusIndex(-1);
    }

    setSelectedValues(function (oldSelectedValues) {
      var newSelectedValues = [];

      if (select) {
        newSelectedValues = [].concat(_toConsumableArray(oldSelectedValues), [_objectSpread(_objectSpread({}, tag), {}, {
          selected: true
        })]);
      } else {
        newSelectedValues = oldSelectedValues.filter(function (item) {
          return item.id !== tag.id;
        });
      }

      return newSelectedValues;
    });
  }, [onChange, id]);

  var showMore = function showMore(id) {
    var _window$cotd;

    setExpandedCategories(expandedCategories.concat(id));

    if (filteredListFocusIndex !== -1) {
      setFilteredListFocusIndex(filteredListFocusIndex + SEARCH_FACET_FILTERED_DISPLAY_AMOUNT);
    }

    if (!((_window$cotd = window.cotd) !== null && _window$cotd !== void 0 && _window$cotd.isMobileWeb) && inputRef.current) {
      inputRef.current.focus({
        preventScroll: true
      });
    }
  };

  var getNestedResult = function getNestedResult() {
    return values.map(function (value) {
      var count = value.count,
          display = value.display,
          id = value.id,
          name = value.name,
          values = value.values;

      var facetItemId = function facetItemId(id) {
        return "".concat(facetId, "-").concat(id);
      };

      var isExpandedCategory = expandedCategories.includes(facetItemId(id));
      return ___EmotionJSX(FacetSubListItem, {
        key: facetItemId(id)
      }, ___EmotionJSX(Span, null, name, " ", ___EmotionJSX(FacetCount, null, "(".concat(count, ")"))), ___EmotionJSX(FacetSubList, null, values === null || values === void 0 ? void 0 : values.map(function (item, index) {
        var hidden = index > SEARCH_FACET_NESTED_DISPLAY_AMOUNT - 1 && !isExpandedCategory;

        if (hidden) {
          return null;
        }

        return ___EmotionJSX(SearchFacetsListItem, {
          checked: item.selected,
          count: item.count,
          display: display,
          id: facetItemId(item.id),
          key: facetItemId(item.id),
          label: item.name,
          onChange: toggleValues,
          value: item
        });
      })), values && values.length > SEARCH_FACET_NESTED_DISPLAY_AMOUNT && !isExpandedCategory && ___EmotionJSX(ShowMore, {
        onClickHandler: function onClickHandler() {
          return showMore(facetItemId(id));
        }
      }));
    });
  };

  return ___EmotionJSX(SearchFacetsContainer, {
    id: facetId
  }, ___EmotionJSX(SearchFacetsHeader, {
    id: facetId,
    isExpanded: isExpanded,
    title: name,
    searchTimeout: searchTimeout,
    selectedLabel: selectedNames,
    onClear: onClearHandler,
    onExpandChange: onExpandChange,
    totalSelected: totalSelected
  }), ___EmotionJSX(SearchFacetsBody, {
    isExpanded: isExpanded,
    px: "16px"
  }, ___EmotionJSX(List, null, getNestedResult())));
};